module.exports = __webpack_public_path__ + "img/logo_larix@2x.3a1850a6.png";